/**
 * @file mark
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import ListPro from '../../components/ListPro';
import Loading from '../../components/Loading';
import TopBar from '../../components/TopBar';

import {fetchCmsapiTagArticleData} from '../../actions/markAction';

import './index.less';

export class Mark extends Component {

    static propTypes = {
        fetchCmsapiTagArticleData: PropTypes.func,
        cmsapiTagArticleData: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object
    };


    constructor(props, context) {
        super(props, context);
        this.state = {
            tagId: this.props.match.params.tagId,
            loadingMore: false
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            const tagId = this.props.match.params.tagId;
            location.href = tagId ? `/tag/${tagId}`
                : '/tag';
        }
    }

    componentDidMount() {
        this.props.fetchCmsapiTagArticleData({tagid: this.state.tagId}).then(data => {
            if (data.data.is_error !== 0) {
                this.props.history.push('/');
            } else {
                const articleList = this.props.cmsapiTagArticleData.itemlist.article_list;
                this.setState({
                    curPage: articleList.cur_page,
                    loadingMore: true
                });
            }
        });
    }

    fetchArticleData() {
        const {tagId, curPage} = this.state;
        this.setState({
            loadingMore: false
        });
        this.props.fetchCmsapiTagArticleData({
            tagid: tagId,
            page: curPage + 1
        }, true).then(() => {
            const articleList = this.props.cmsapiTagArticleData.itemlist.article_list;
            this.setState({
                curPage: articleList.cur_page,
                loadingMore: articleList.total_page > articleList.cur_page
            });
        });

    }

    render() {
        this.shareWX({
            title: '标签-百度安全社区',
            content: ' '
        });

        const cmsapiTagArticleData = this.props.cmsapiTagArticleData.itemlist;
        const loadingMore = this.state.loadingMore;
        let isMore = true;

        if (!this.isEmptyobj(cmsapiTagArticleData)) {
            const articleList = cmsapiTagArticleData.article_list;
            if (articleList.total_page > articleList.cur_page) {
                isMore = true;
            } else {
                isMore = false;
            }
        }


        return (
            <div className={'mark'}>
                <div className={'top-bar-box'}>
                    <TopBar/>
                </div>

                {
                    !this.isEmptyobj(cmsapiTagArticleData)
                        ? <div className={'mark-title mui-flex section'}>
                            <div className={'big'}>#{cmsapiTagArticleData.tagname[cmsapiTagArticleData.tagid]}#</div>
                            <div className={'small'}>{cmsapiTagArticleData.article_list.total}篇文章</div>
                        </div> : ''
                }

                <div className={'page-box'}>
                    {!this.isEmptyobj(cmsapiTagArticleData)
                        ? cmsapiTagArticleData.article_list.datalist.map(item => {
                            return <a href={`/m/forum/page/${item.aid}`} key={item.aid} className={'section'}>
                                <ListPro
                                    title={item.title}
                                    time={item.publish_time.slice(5, 10)}
                                    brief={`${item.pv}人阅读`}
                                    imgSrc={item.pic}
                                    target={'_black'}
                                />
                            </a>;
                        }) : ''
                    }
                </div>
                {
                    !this.isEmptyobj(cmsapiTagArticleData) ? <Loading
                        type={isMore}
                        isLoad={loadingMore}
                        callbackFn={this.fetchArticleData.bind(this)}
                        style={{paddingTop: '0.6rem', paddingBottom: '0.8rem'}}
                    /> : ''
                }
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        cmsapiTagArticleData: state.cmsapiTagArticleData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiTagArticleData: (aidObj, isMore) => fetchCmsapiTagArticleData(dispatch, aidObj, isMore)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Mark);





// WEBPACK FOOTER //
// ./src/containers/mark/index.js